module.exports = "/_next/static/images/Features@2x-e84e22165498b6513aa88e064d9163ae.webp";